import { Company } from '../../register/organizational/company';
import { AccountPlan } from './account-plan';

export class CompanyAccountPlan {
    id: number;
    company: Company;
    accountPlan: AccountPlan;
    active: boolean;
}
